<template>
  <div class="datapeople-anywhere-login-success">
    <div class="extension-wrapper">
      <h5 class="mb-4">
        {{ `Congratulations, ${authData.firstName}! You're logged into JobNav Anywhere.` }}
      </h5>
      <p class="ma-4">
        You can now edit jobs from within your ATS.
      </p>
      <div class="mb-4">
        <DpplSvg
          name="image"
          file-name="image-login"
        />
      </div>
      <DpplAutoSizedButton
        class="close-button"
        @click="closeWindow()"
      >
        Close
      </DpplAutoSizedButton>
      <div class="mt-4">
        <span>Having trouble?
          <a
            href="mailto:support@datapeople.io?subject=Having%20issues%20on%20Datapeople%20Anywhere"
            class="support-link"
          >
            Contact Us
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { mapState } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { getLocalStorageObject } from '@/helpers/localStorage';

export default {
  name: 'DatapeopleAnywhereLoginSuccess',
  components: { DpplAutoSizedButton, DpplSvg },
  computed: {
    ...mapState(useAppAuthData, ['authData']),
  },
  mounted() {
    getLocalStorageObject({ key: 'datapeopleAnywhereRedirect', remove: true });
  },
  methods: {
    closeWindow() {
      window.close();

      /*
      Chrome will not allow us to close the window if it was not opened
      by the app (i.e. if it's opened by an external source'). In such a case,
      the user will have to close the window manually
      */
      setTimeout(() => {
        if (window && !window.closed) {
          window.alert('Please close this browser tab manually.');
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.datapeople-anywhere-login-success {
  display: flex;
  justify-content: center;
  background-color: @white;
  width: 100%;
  height: 100%;
  .extension-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
    height: 538px;
    width: 380px;
    .close-button {
      width: 100%;
    }
    .support-link {
      text-decoration: none;
      color: @text-brand;
      font-weight: 500;
    }
  }
}
</style>
